import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Megaphone, PenTool, Share2, Mail, Search,
  DollarSign, BarChart3, Zap, Settings, ChevronLeft, Bot,
} from "lucide-react";
import { useState } from "react";

const navigation = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/campaigns", icon: Megaphone, label: "Campaigns" },
  { to: "/content", icon: PenTool, label: "Content Studio" },
  { to: "/social", icon: Share2, label: "Social Hub" },
  { to: "/email", icon: Mail, label: "Email Marketing" },
  { to: "/seo", icon: Search, label: "SEO Tools" },
  { to: "/ads", icon: DollarSign, label: "Ad Manager" },
  { to: "/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/automations", icon: Zap, label: "Automations" },
  { to: "/autopilot", icon: Bot, label: "AI Autopilot" },
  { to: "/settings", icon: Settings, label: "Settings" },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside
      className={`${
        collapsed ? "w-16" : "w-64"
      } bg-white border-r border-gray-200 flex flex-col transition-all duration-200 ease-in-out`}
    >
      {/* Logo */}
      <div className="h-16 flex items-center gap-3 px-4 border-b border-gray-200">
        <img
          src="/migra-logo-48.png"
          alt="MigraMarket logo"
          className="w-8 h-8 flex-shrink-0"
        />
        {!collapsed && (
          <div className="overflow-hidden">
            <h1 className="text-lg font-bold text-gray-900 leading-tight">MigraMarket</h1>
            <p className="text-[10px] text-gray-400 leading-none">Enterprise Marketing</p>
          </div>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4 space-y-1 px-2 overflow-y-auto">
        {navigation.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive
                  ? "bg-blue-50 text-blue-700"
                  : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`
            }
          >
            <item.icon className="w-5 h-5 flex-shrink-0" />
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Collapse Toggle */}
      <button
        onClick={() => setCollapsed(!collapsed)}
        className="h-12 flex items-center justify-center border-t border-gray-200 text-gray-400 hover:text-gray-600 transition-colors"
      >
        <ChevronLeft className={`w-5 h-5 transition-transform ${collapsed ? "rotate-180" : ""}`} />
      </button>
    </aside>
  );
}
